import { useMemo } from "react"
import * as yup from "yup"
import i18n from "@/i18n"

export const useCreateUserValidationSchema = () =>
  useMemo(
    () =>
      yup.object({
        firstName: yup
          .string()
          .label(i18n.t("app.settings.users.labels.first_name"))
          .required(i18n.t("app.settings.users.errors.first_name_required")),
        lastName: yup
          .string()
          .label(i18n.t("app.settings.users.labels.last_name"))
          .required(i18n.t("app.settings.users.errors.last_name_required")),
        email: yup
          .string()
          .label(i18n.t("app.settings.users.labels.email"))
          .email(i18n.t("app.settings.users.errors.email_invalid"))
          .required(i18n.t("app.settings.users.errors.email_required")),
        password: yup
          .string()
          .label(i18n.t("app.settings.users.labels.password"))
          .required(i18n.t("app.settings.users.errors.password_required"))
          .min(8, i18n.t("app.settings.users.errors.password_min_length")),
        passwordConfirmation: yup
          .string()
          .label(i18n.t("app.settings.users.labels.password_confirmation"))
          .required(i18n.t("app.settings.users.errors.password_confirmation_required"))
          .oneOf([yup.ref("password")], i18n.t("app.settings.users.errors.passwords_must_match")),
        phone: yup.string().label(i18n.t("app.settings.users.labels.phone")),
        position: yup.string().label(i18n.t("app.settings.users.labels.position")),
        country: yup.string().label(i18n.t("app.settings.users.labels.country")),
        address: yup.string().label(i18n.t("app.settings.users.labels.address")),
        city: yup.string().label(i18n.t("app.settings.users.labels.city")),
        postcode: yup.string().label(i18n.t("app.settings.users.labels.postcode")),
        roles: yup.array(),
      }),
    [i18n.locale],
  )
